/**
 * Card-back colourways.
 *
 * A personal preference rather than a house rule: it changes nothing about the
 * game, so there is no reason to make everyone at the table agree, or to spend
 * a server round-trip on it. Each player sees their own choice.
 */
export interface CardBack {
  id: string;
  label: string;
  /** Top-left of the diagonal gradient. */
  from: string;
  /** Bottom-right of the diagonal gradient. */
  to: string;
}

export const CARD_BACKS: readonly CardBack[] = [
  { id: 'felt', label: 'Felt green', from: '#235444', to: '#143026' },
  { id: 'claret', label: 'Claret', from: '#6d2233', to: '#33101a' },
  { id: 'navy', label: 'Navy', from: '#24466e', to: '#101f34' },
  { id: 'plum', label: 'Plum', from: '#4e2757', to: '#26122a' },
  { id: 'oak', label: 'Oak', from: '#7a5732', to: '#3a2915' },
  { id: 'slate', label: 'Slate', from: '#3b4248', to: '#191d21' },
];

export const DEFAULT_CARD_BACK = CARD_BACKS[0] as CardBack;

export function findCardBack(id: string | null | undefined): CardBack {
  return CARD_BACKS.find((back) => back.id === id) ?? DEFAULT_CARD_BACK;
}
